<div class="p-6">

  <!-- Header -->
  <div class="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
    <h3 class="font-bold">
      {{ '::TotalBottlesSold' | abpLocalization }}
    </h3>
  </div>

  <!-- Filtros -->
  <div class="flex flex-col md:flex-row items-center gap-2 mt-3">

    <div class="flex-1">
      <app-metro-search-input 
        [ngModel]="searchKeyword || ''"
        (search)="onSearch($event)" 
        (cleared)="onClearSearch()">
      </app-metro-search-input>
    </div>

    <div class="w-full md:w-80">
      <app-metro-date-input-picker [modeInput]="'range'" [startDateInput]="dateRange.start"
        [endDateInput]="dateRange.end" (rangeSelectedChange)="onDateRangeChange($event)">
      </app-metro-date-input-picker>
    </div>

    <app-metro-button [text]="'::GenerateExcel' | abpLocalization" variant="secondary"
      (click)="generateWineSalesExcel()" [disabled]="!dateRange.start || !dateRange.end" [size]="'lg'"
      [loading]="isLoading">
    </app-metro-button>

    </div>

    <!-- Tabla -->
    <div class="flex flex-col overflow-x-auto rounded-lg border-1 border-gray-700 mt-2">
      <app-metro-table [columns]="columns" [data]="reportData" [pageSize]="pageSize" [currentPage]="currentPage"
        [isServerPaginated]="true" [totalItems]="totalCount" (pageChange)="onPageChange($event)">
      </app-metro-table>
    </div>

</div>
